import { Outlet, generatePath } from 'react-router-dom';
import ChartAccountsColumn from '../../../components/charts/column/column-accounts';
import usePrimaryAccountsList from './hooks/use-list';

import ROUTES from '../../../routes';

import cn from '../styles.module.css';

const ChartAccounts = (): React.JSX.Element => {
  const {
    categoryId,
    groupId,
    primaryAccountId,
    accounts,
    isFetching,
    isLoading,
  } = usePrimaryAccountsList();

  return (
    <>
      <div className={cn.columnWrapper}>
        <ChartAccountsColumn
          groupId={groupId}
          categoryId={categoryId}
          accounts={accounts}
          isLoading={isLoading || isFetching}
          path={
            groupId !== 'groupId'
              ? generatePath(ROUTES.PRIMARY_ACCOUNT_ADD, {
                  categoryId: categoryId || 'categoryId',
                  groupId: groupId || 'groupId',
                  primaryAccountId: primaryAccountId || 'primaryAccountId',
                })
              : ''
          }
        />
      </div>
      <Outlet />
    </>
  );
};

export default ChartAccounts;
